import { takeEvery, fork, put, all, call, takeLatest } from "redux-saga/effects"

import {
  ADD_CARD,
  GET_CARD_LIST,
  REMOVE_CARD,
  DEFAULT_CARD,
  GET_INVOICES,
  GET_PLAN,
  ADD_BILL_ADDRESS,
  GET_BILL_ADDRESS_DETAILS,
  EDIT_BILL_ADDRESS,
  GET_TIMEZONES_LIST,
  UPDATE_TIMEZONE,
} from "./actionTypes"

import { addCardFailed, addCardSuccessful, getCardListSuccessful, getCardListFailed, removeCardSuccessful, removeCardFailed, defaultCardSuccessful, defaultCardFailed, getInvoicesSuccessful, getPlanSuccessful, getPlanFailed, apiErrorBillDet, getInvoicesFailed, addBillAddSuccessful, addBillAddFailed, getBillAddSuccessful, getBillAddFailed, editBillAddSuccessful, editBillAddFailed, setTimeZonesList, setGetStartedSection } from "./actions"
import { LystfacePayMethAdd, LystfacePayMethList, LystfacePayMethRemove, LystfaceDefPayMeth, LystfaceCmpInv, LystfaceCmpActPlan, LystfaceGetBillAddress, LystfaceAddBillAddress, LystfaceEditBillAddress, LystfaceTimezonesList, LystfaceUpdateTimeZone, LystfaceGetStartedSection } from "../../../helpers/lystface_helper"
import { SetConstDetails } from "../../actions";

function* addCardFn({ payload: { card, history } }) {
  let cardAdd;
  try {
    cardAdd = yield call(LystfacePayMethAdd, card)
    const { responseCode, responseMessage, response, responseStatus, showMessage } = cardAdd
    if (responseCode == true) {
      yield put(SetConstDetails({ card_setup: true }))
      yield put(addCardSuccessful(cardAdd))
      if (response?.company?.is_new && process.env.REACT_APP_NODE === "prod") {
        if (window.gtag_report_conversion) {  //ui-cmd-7
          console.log("success-gtag");
          window.gtag_report_conversion('');
        }
      }
    }
    else {
      yield put(addCardFailed(cardAdd))
    }
  } catch (e) {
    yield put(addCardFailed({ responseMessage: 'There was an error adding the payment method, please try again later!' }))
    yield put(apiErrorBillDet())
  }
}
function* getCardsListFn() {
  let cardList;
  try {
    cardList = yield call(LystfacePayMethList)
    const { responseCode, responseMessage, response, responseStatus, showMessage } = cardList
    if (responseCode) {
      yield put(getCardListSuccessful(cardList))
    }
    else {
      yield put(getCardListFailed(cardList))
    }
  } catch (e) {
    yield put(apiErrorBillDet())
  }
}
function* removeCardFn({ payload: { card, history } }) {
  let cardRemove;
  try {
    cardRemove = yield call(LystfacePayMethRemove, card)
    const { responseCode, responseMessage, response, responseStatus, showMessage } = cardRemove
    if (responseCode == true) {
      yield put(removeCardSuccessful(cardRemove))
    }
    else {
      yield put(removeCardFailed(cardRemove))
    }
  } catch (e) {
    yield put(apiErrorBillDet())
  }
}
function* defaultCardFn({ payload: { card, history } }) {
  let cardDef;
  try {
    cardDef = yield call(LystfaceDefPayMeth, card)
    const { responseCode, responseMessage, response, responseStatus, showMessage } = cardDef
    if (responseCode == true) {
      yield put(defaultCardSuccessful(cardDef))
    }
    else {
      yield put(defaultCardFailed(cardDef))
    }
  } catch (e) {
    yield put(apiErrorBillDet())
  }
}
function* getInvFn({ payload: { invsearch, history } }) {
  let cmpInv;
  try {
    cmpInv = yield call(LystfaceCmpInv, invsearch)
    const { responseCode, responseMessage, response, responseStatus, showMessage } = cmpInv
    if (responseCode) {
      yield put(getInvoicesSuccessful(cmpInv))
    }
    else {
      yield put(getInvoicesFailed(cmpInv))
    }
  } catch (e) {
    yield put(apiErrorBillDet())
  }
}
function* getPlanFn() {
  let planDet;
  try {
    planDet = yield call(LystfaceCmpActPlan)
    const { responseCode, responseMessage, response, responseStatus, showMessage } = planDet
    if (responseCode) {
      yield put(getPlanSuccessful(planDet))
    }
    else {
      yield put(getPlanFailed(planDet))
    }
  } catch (e) {
    yield put(apiErrorBillDet())
  }
}
function* addBillAddFn({ payload: { Add, history } }) {
  let billDet;
  try {
    billDet = yield call(LystfaceAddBillAddress, Add)
    console.log(billDet)
    const { responseCode, responseMessage, response, responseStatus, showMessage } = billDet
    if (responseCode == true) {
      yield put(SetConstDetails({ billing_setup: true }))
      yield put(addBillAddSuccessful(billDet))
    }
    else {
      yield put(addBillAddFailed(billDet))
    }
  } catch (e) {
    yield put(apiErrorBillDet())
    yield put(addBillAddFailed({ responseMessage: 'There was an error adding the billing address, please try again later!' }))
  }
}
function* editBillAddFn({ payload: { Add, history } }) {
  let billDet;
  try {
    billDet = yield call(LystfaceEditBillAddress, Add)
    const { responseCode, responseMessage, response, responseStatus, showMessage } = billDet
    if (responseCode == true) {
      yield put(editBillAddSuccessful(billDet))
    }
    else {
      yield put(editBillAddFailed(billDet))
    }
  } catch (e) {
    yield put(editBillAddFailed({ responseMessage: 'There was an error updating the billing address, please try again later!' }))
    yield put(apiErrorBillDet())
  }
}


function* getBillAdd() {
  let billAddressDet;
  try {
    billAddressDet = yield call(LystfaceGetBillAddress)
    const { responseCode, responseMessage, response, responseStatus, showMessage } = billAddressDet
    if (responseCode) {
      yield put(getBillAddSuccessful(billAddressDet))
    }
    else {
      yield put(getBillAddFailed(billAddressDet))
    }
  } catch (e) {
    yield put(apiErrorBillDet())
  }
}
function* getListOfTimeZonesSaga() {
  let timeZoneRes;
  try {
    timeZoneRes = yield call(LystfaceTimezonesList)
    console.log('timeeeeeeeeeeeeee', timeZoneRes)
    if (timeZoneRes?.responseCode) {
      yield put(setTimeZonesList({ response: timeZoneRes?.response?.data }))
    }
    else {
      yield put(setTimeZonesList({ response: timeZoneRes?.response?.data, responseMessage: timeZoneRes?.responseMessage }))
    }
  } catch (e) {
    yield put(setTimeZonesList({ responseMessage: 'There was an error fetching the timezones list, please try again later!' }))
  }
}
function* updateTimeZoneSaga({ payload }) {
  let timeZoneRes;
  try {
    timeZoneRes = yield call(LystfaceUpdateTimeZone, payload)
    if (timeZoneRes?.responseCode) {
      yield put(setTimeZonesList({ responseMessage: timeZoneRes?.responseMessage, responseStatus: timeZoneRes?.responseStatus, selectedTimeZone: payload?.timezone, updateTimeZoneLoading: false }))
    }
    else {
      yield put(setTimeZonesList({ responseMessage: timeZoneRes?.responseMessage, responseStatus: timeZoneRes?.responseStatus, updateTimeZoneLoading: false }))
    }
  } catch (e) {
    yield put(setTimeZonesList({ responseMessage: 'There was an error updating timezone, please try again later!', updateTimeZoneLoading: false }))
  }
}



function* billSetSaga() {
  yield takeEvery(ADD_CARD, addCardFn)
  yield takeEvery(GET_INVOICES, getInvFn)
  yield takeEvery(GET_PLAN, getPlanFn)
  yield takeLatest(GET_CARD_LIST, getCardsListFn)
  yield takeEvery(REMOVE_CARD, removeCardFn)
  yield takeEvery(DEFAULT_CARD, defaultCardFn)
  yield takeEvery(ADD_BILL_ADDRESS, addBillAddFn)
  yield takeEvery(GET_BILL_ADDRESS_DETAILS, getBillAdd)
  yield takeEvery(EDIT_BILL_ADDRESS, editBillAddFn)
  yield takeEvery(GET_TIMEZONES_LIST, getListOfTimeZonesSaga)

}
export default billSetSaga
